
import Vue from "vue";
import { Component } from "vue-property-decorator";
import SingularityPanelHeader from "../PanelHeader/SingularityPanelHeader.vue";
import SingularityOption from "../components/SingularityOption.vue";
import { singularityStore, uiStore } from "@/store/store";
import NiceButton from "@/components/UI/NiceButton.vue";
import { generateSectionWithAI } from "@/futurelayer/generate-section";
import { insertSectionAfterNode } from "@/lib/singularity/section-add-or-swap";
import { SECTION_SLUG } from "@/lib/elements/constants";
import { logEvent } from "@/util/tracking";

@Component({
  components: {
    SingularityPanelHeader,
    SingularityOption,
    NiceButton
  }
})
export default class NewSectionPanel extends Vue {
  openLibraryModal() {
    singularityStore.setSectionAddOrSwapPanelState({
      mode: "add_after",
      sectionId: this.currentlyActiveSectionId
    });
    singularityStore.setSectionLibraryModalState(true);
    logEvent("FutureLayer New Section: Library Selected");
  }

  get currentlyActiveSectionId() {
    if (!uiStore.activeElement) return null;
    if (uiStore.activeElement.data.type !== SECTION_SLUG) return null;
    return uiStore.activeElement.id;
  }

  get childTitle() {
    if (this.addNewSectionPanelState === null) return "Add";
    if (this.addNewSectionPanelState.mode === "breakdance_ai")
      return "Build with AI";
    return "Add";
  }

  setBreakdanceAIMode() {
    singularityStore.setAddNewSectionPanelState({
      mode: "breakdance_ai"
    });
    logEvent("FutureLayer New Section: AI Selected");
  }

  goBack() {
    singularityStore.setAddNewSectionPanelState(null);
  }

  get addNewSectionPanelState() {
    return singularityStore.addNewSectionPanelState;
  }

  option: "library" | "breakdance_ai" | null = null;

  sectionDescription = "";
  isGenerating = false;

  async generateSection() {
    if (!this.sectionDescription.trim() || this.isGenerating) return;

    this.isGenerating = true;
    const section = await generateSectionWithAI(this.sectionDescription, false);

    logEvent("FutureLayer New Section: AI Generation Started", {
      description: this.sectionDescription
    });

    if (section) {
      const insertedSection = insertSectionAfterNode(
        section,
        this.currentlyActiveSectionId ?? -1
      );
      if (insertedSection) {
        uiStore.activateElement(insertedSection);
      }
      this.sectionDescription = "";
      singularityStore.setAddNewSectionPanelState(null);
      singularityStore.setSingularityLeftPanel("page_structure");
    } else {
      console.error("Failed to generate section");
    }
    this.isGenerating = false;
  }
}
